import { Check, Pencil, Plus, Trash2 } from "lucide-react";
import { useState } from "react";

const newKey = () => `c_${Math.random().toString(16).slice(2, 10).padEnd(8, "0")}`;

export function ColumnTools({ column, count, columns, onSave }) {
  const [editing, setEditing] = useState(false);
  const [title, setTitle] = useState(column.title);
  const rename = async () => {
    if (!title.trim() || title === column.title) { setEditing(false); return; }
    if (await onSave(columns.map((c) => (c.key === column.key ? { ...c, title: title.trim() } : c)))) setEditing(false);
  };
  const remove = () => {
    if (!window.confirm(`Supprimer la colonne « ${column.title} » ?`)) return;
    onSave(column.system ? columns.map((c) => (c.key === column.key ? { ...c, hidden: true } : c)) : columns.filter((c) => c.key !== column.key));
  };
  if (editing) {
    return (
      <form className="col-tools col-rename" onSubmit={(e) => { e.preventDefault(); rename(); }} onClick={(e) => e.stopPropagation()}>
        <input autoFocus value={title} onChange={(e) => setTitle(e.target.value)} onBlur={rename} data-testid={`column-rename-input-${column.key}`} />
        <button type="submit" className="pj-icon-btn" aria-label="Valider" data-testid={`column-rename-save-${column.key}`}><Check size={14} /></button>
      </form>
    );
  }
  return (
    <span className="col-tools">
      <button type="button" className="pj-icon-btn" onClick={() => { setTitle(column.title); setEditing(true); }} title="Renommer" data-testid={`column-rename-${column.key}`}><Pencil size={13} /></button>
      {count === 0 && <button type="button" className="pj-icon-btn" onClick={remove} title="Supprimer (colonne vide)" data-testid={`column-delete-${column.key}`}><Trash2 size={13} /></button>}
    </span>
  );
}

export function AddColumn({ columns, onSave }) {
  const [title, setTitle] = useState("");
  const add = async (e) => {
    e.preventDefault();
    if (title.trim() && (await onSave([...columns, { key: newKey(), title: title.trim(), subtitle: "", color: "col-gray", hidden: false }]))) setTitle("");
  };
  const hidden = columns.filter((c) => c.hidden);
  return (
    <div className="kanban-column col-add" data-testid="column-add">
      <form onSubmit={add}>
        <input placeholder="Nouvelle colonne" value={title} onChange={(e) => setTitle(e.target.value)} data-testid="column-add-input" />
        <button type="submit" className="secondary-button" disabled={!title.trim()} data-testid="column-add-btn"><Plus size={15} />Ajouter</button>
      </form>
      {hidden.length > 0 && (
        <div className="col-hidden">
          <small>Colonnes supprimées :</small>
          {hidden.map((c) => <button key={c.key} type="button" className="link-button" onClick={() => onSave(columns.map((x) => (x.key === c.key ? { ...x, hidden: false } : x)))} data-testid={`column-restore-${c.key}`}>Rétablir « {c.title} »</button>)}
        </div>
      )}
    </div>
  );
}
